var uris = [
  [1, require("/opt/buildhome/repo/js/features/pots/img/autosave_growth_graphics.png?asset")],
  [2, require("/opt/buildhome/repo/js/features/pots/img/autosave_growth_graphics@2x.png?asset")],
  [3, require("/opt/buildhome/repo/js/features/pots/img/autosave_growth_graphics@3x.png?asset")]
];

module.exports = {
  get uri() {
    var ratio = (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
    for (var i = 0; i < uris.length; i++) {
      if (uris[i][0] >= ratio) return uris[i][1];
    }
    return uris[uris.length - 1][1];
  },
  width: 311,
  height: 152,
  toString: function () {
    return this.uri;
  },
};
